import { AfterViewInit, Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subject, BehaviorSubject, Observable } from 'rxjs';
import io, { Socket } from 'socket.io-client';
import { LoginService } from './login.service';
import { NgZone } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SocketService implements OnDestroy {
  private heartbeatInterval: any;
  private pongTimeout: any;
  private missedPongs = 0;
  private readonly HEARTBEAT_INTERVAL = 30000; // 30 seconds
  private readonly PONG_TIMEOUT = 5000; // 5 seconds
  private readonly MAX_MISSED_PONGS = 3;

  currentUser: any;

  private ipSubject: Subject<string> = new Subject<string>();
  public ip = this.ipSubject.asObservable();
  socket: Socket & { ip?: string };
  listeners = [];
  webSocketUrl: any;
  on: any;
  private reconnectingSubject = new BehaviorSubject<boolean>(false);
  reconnecting$: Observable<boolean> = this.reconnectingSubject.asObservable();

  constructor(
    private loginService: LoginService,
    private ngZone: NgZone,
  ) {
    this.loginService.currentUser.subscribe((x) => {
      this.currentUser = x;
      if (this.currentUser && this.currentUser.config && this.currentUser.config.websocketUrl) {
        this.initializeSocket(this.currentUser.config.websocketUrl);
      }
    });
  }

  private initializeSocket(websocketUrl: string): void {
    // Disconnect existing socket if any
    if (this.socket) {
      this.socket.disconnect();
    }

    //  this.socket = io(this.currentUser.config.websocketUrl);


    this.webSocketUrl = this.currentUser?.config.websocketUrl;
    console.log("trying to connect to: ", this.webSocketUrl);
    // this.socket = io(this.webSocketUrl, {
    //   reconnection: false, transports: ['websocket']
    // });
    this.socket = io(this.webSocketUrl, {
      reconnection: true, // Changed from false
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 60000,
      transports: ['websocket']
    });

    this.socket.on('outdated', () => {
      // VersionUpdateService.open();
    });

    // this.socket.on('socket.ip', function (ip) {
    //   this.ngZone.run(() => {
    //     this.socket.ip = ip;
    //     this.ipSubject.next(ip);
    //   });
    // });

    this.socket.on('socket.ip', (ip) => {
      this.ngZone.run(() => {
        this.socket.ip = ip;
        this.ipSubject.next(ip);
      });
    });

    this.socket.on('connect', () => {
      console.log('✅ Socket connected');
      this.missedPongs = 0;
      this.reconnectingSubject.next(false);
      this.startHeartbeat();
    });

    this.socket.on('disconnect', (reason) => {
      console.log('🔌 Socket disconnected:', reason);
      this.reconnectingSubject.next(true);
      this.stopHeartbeat();
    });

    this.socket.on('pong', () => {
      console.log('💓 Pong received');
      this.missedPongs = 0;
      clearTimeout(this.pongTimeout);
    });
  }

  ngOnDestroy() {
    this.stopHeartbeat();
    this.listeners.forEach(listener => {
      this.socket.removeListener(listener.event, listener.handler);
    });
    this.socket.off('connect');
    this.socket.off('disconnect');
    this.socket.off('pong');
  }

  private startHeartbeat() {
    this.stopHeartbeat();

    this.heartbeatInterval = setInterval(() => {
      if (this.socket.connected) {
        console.log('📡 Sending ping...');
        this.socket.emit('ping', { timestamp: Date.now() });

        this.pongTimeout = setTimeout(() => {
          this.missedPongs++;
          console.warn(`⚠️ Missed pong ${this.missedPongs}/${this.MAX_MISSED_PONGS}`);

          if (this.missedPongs >= this.MAX_MISSED_PONGS) {
            console.error('❌ Connection dead, reconnecting...');
            this.socket.disconnect();
            this.socket.connect();
          }
        }, this.PONG_TIMEOUT);
      }
    }, this.HEARTBEAT_INTERVAL);
  }

  private stopHeartbeat() {
    if (this.heartbeatInterval) {
      clearInterval(this.heartbeatInterval);
      this.heartbeatInterval = null;
    }
    if (this.pongTimeout) {
      clearTimeout(this.pongTimeout);
      this.pongTimeout = null;
    }
  }

  public scoped = () => {
    return {
      on: (event, handler) => {
        const listener = { event, handler };
        this.listeners.push(listener);
        this.socket.on(event, handler);
        return this;
      }
    };
  }

  //   listenForAccessToken(){


  //   //     this.socket.on('user.keys.accessToken.generated', (token: any) => {



  //   //     }
  //   // }

  //  this.socket.on('user.keys.accessToken.generated', function(token) {


  //   })


  // }
}